import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DefaultValuesService } from 'src/app/services/defaultvalues.service';
import { EquipmentManagenementService } from 'src/app/services/equipmentmanagement.service';
import { OtaSettingsListComponent } from './otasettings-list/otasettings-list.component';

@Component({
    selector: 'otasettings',
    standalone: false,
    templateUrl: './otasettings.component.html',
    styleUrls: ['./otasettings.component.less', '../../../../style/new-generic-styles.component.less', '../fieldsettings.component.less'],
    encapsulation: ViewEncapsulation.None
})
export class OtaSettingsComponent {
    title = "Equipment Management Configuration";
    selectedLevel = {} as EquipmentConfigurationLevel
    userLevels: EquipmentConfigurationLevel[] = [];

    @ViewChild(OtaSettingsListComponent) list!: OtaSettingsListComponent;
    constructor(
        private readonly emtService: EquipmentManagenementService,
        public defaults: DefaultValuesService,
        private readonly matDialog: MatDialog
    ) { }

    onNewLevelSelected(level: EquipmentConfigurationLevel) {
        this.selectedLevel = level;
        this.list.changeSelectedLevel(level);
    }
}
